"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "buti": {
    "358f17bb": [{
      "hkey": "62763173",
      "slug": "cascine-la-croce",
      "name": "Cascine-La Croce",
      "primary": true,
      "skipSearch": false
    }],
    "cascine": [{
      "hkey": "62763173",
      "slug": "cascine-la-croce",
      "name": "Cascine-La Croce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "52eb2cc0": [{
      "hkey": "780cd548",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "panicale-sopra-buti": [{
      "hkey": "780cd548",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "buti"
    }]
  }
};
exports["default"] = _default;